export default __webpack_public_path__ + "static/media/project-4.e4bdf0e7.jpg";